import React from "react";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";
import "../styles/components/control-box.css";

class ControlBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      playing: false,
      speedRatio: 1
    };
  }

  togglePlay = () => {
    this.setState(
      prevState => ({
        playing: !prevState.playing
      }),
      () => {
        this.props.togglePlay(this.state.playing);
      }
    );
  };

  forwardSpeedUp = () => {
    this.setState(
      prevState => {
        let speedRatio;
        let newSpeedRatio = prevState.speedRatio / 2;
        if (prevState.speedRatio < 0) {
          newSpeedRatio = 1;
        }
        if (newSpeedRatio >= 1 / 4096) {
          speedRatio = newSpeedRatio;
        } else {
          speedRatio = prevState.speedRatio;
        }
        return {
          speedRatio
        };
      },
      () => {
        this.props.getSpeedRatio(this.state.speedRatio);
      }
    );
  };

  rewindSpeedUp = () => {
    this.setState(
      prevState => {
        let speedRatio;
        let newSpeedRatio = prevState.speedRatio / 2;
        if (prevState.speedRatio > 0) {
          newSpeedRatio = -1;
        }
        if (newSpeedRatio <= -(1 / 4096)) {
          speedRatio = newSpeedRatio;
        } else {
          speedRatio = prevState.speedRatio;
        }
        return {
          speedRatio
        };
      },
      () => {
        this.props.getSpeedRatio(this.state.speedRatio);
      }
    );
  };

  render() {
    return (
      <div className="control-box">
        <Tooltip
          title="rewind"
          size="medium"
          theme="transparent"
          arrow="true"
          position="bottom"
        >
          <button type="button" onClick={this.rewindSpeedUp}>
            <ion-icon name="ios-rewind" />
          </button>
        </Tooltip>
        <Tooltip
          title={this.state.playing ? "pause" : "play"}
          size="medium"
          theme="transparent"
          arrow="true"
          position="bottom"
        >
          <button type="button" onClick={this.togglePlay}>
            {this.state.playing ? (
              <ion-icon name="ios-pause" />
            ) : (
              <ion-icon name="ios-play" />
            )}
          </button>
        </Tooltip>
        <Tooltip
          title="fast forward"
          size="medium"
          theme="transparent"
          arrow="true"
          position="bottom"
        >
          <button type="button" onClick={this.forwardSpeedUp}>
            <ion-icon name="ios-fastforward" />
          </button>
        </Tooltip>
        <Tooltip
          title="calendar"
          size="medium"
          theme="transparent"
          arrow="true"
          position="bottom"
        >
          <button type="button" onClick={this.props.toggleTimePicker}>
            <ion-icon name="ios-calendar" />
          </button>
        </Tooltip>
      </div>
    );
  }
}

export default ControlBox;
